import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import MenuIcon from '@mui/icons-material/Menu';
import { Button, Grid, IconButton, InputAdornment, Menu, MenuItem, Toolbar } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { useHistory } from 'react-router';

import StyledFilledTextField from '../components/StyledFilledTextField';
import { ContextStore } from '../store/contextStore';

const useStyles = makeStyles((theme) => ({
    toolbarRoot: {
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            margin: 0,
        },
    },
    hidden: {
        visibility: 'hidden',
    },
    grow: {
        flexGrow: 1,
    },
}));

// const GuestRoleUniqId = Math.floor(Math.random() * Math.floor(Math.random() * Date.now()));

export const NotificationStringToolbar = (props) => {
    const history = useHistory();
    const classes = useStyles();
    const { hasPerm } = React.useContext(ContextStore);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    //Query debounce
    const [searchTerm, setSearchTerm] = React.useState(props.query ? props.query : '');
    const [timeoutId, setTimeoutId] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    // const handleAddToursFilters = (ev, tour) => {
    //     if (!tour) {
    //         setRecordListFilters((prev) => ({ ...prev, tour: null }));
    //         props.setRecordListPageReset(new Date().toString());
    //         props.setLastUpdate(new Date().toString());

    //         return;
    //     }
    //     setRecordListFilters((prev) => ({ ...prev, tour: tour }));
    //     props.setRecordListPageReset(new Date().toString());
    //     props.setLastUpdate(new Date().toString());
    // };

    // const handleTriggersSelect = (ev, nv) => {
    //     setRecordListFilters((prev) => ({ ...prev, role: nv }));
    //     props.setRecordListPageReset(new Date().toString());
    //     props.setLastUpdate(new Date().toString());
    // };

    // const handleDeliveryType = (ev, nv) => {
    //     if (!nv) {
    //         setRecordListFilters((prev) => ({ ...prev, delivery_method: null }));
    //         props.setRecordListPageReset(new Date().toString());
    //         props.setLastUpdate(new Date().toString());
    //         return;
    //     }
    //     setRecordListFilters((prev) => ({ ...prev, delivery_method: nv }));
    //     props.setRecordListPageReset(new Date().toString());
    //     props.setLastUpdate(new Date().toString());
    // };

    const onQueryChange = (e) => {
        const searchTerm = e.target.value;
        setSearchTerm(searchTerm);
        clearTimeout(timeoutId);
        setTimeoutId(
            setTimeout(() => {
                // Call the API after the debounce timeout
                props.setQuery(searchTerm);
                history.push({ search: '' });
            }, 1000)
        );
    };

    React.useEffect(() => {
        // Cleanup function to clear the timeout on unmount and re-render
        return () => {
            clearTimeout(timeoutId);
        };
    }, [timeoutId]);

    // const handleEventFilterSelect = (ev, nv) => {
    //     if (!nv) {
    //         setRecordListFilters((prev) => ({ ...prev, event: null }));
    //         props.setRecordListPageReset(new Date().toString());
    //         props.setLastUpdate(new Date().toString());
    //         return;
    //     }

    //     setRecordListFilters((prev) => ({ ...prev, event: nv }));
    //     props.setRecordListPageReset(new Date().toString());
    //     props.setLastUpdate(new Date().toString());
    // };

    const onBatchDelete = () => {
        props.batchDelete();
        setAnchorEl(null);
    }

    return (
        <Toolbar disableGutters={true} className={classes.toolbarRoot} sx={{ minHeight: 0 }}>
            <Grid container direction="row" spacing={2} alignItems="center">
                <Grid item xs={12} container spacing={2} alignItems={'center'}>
                    <Grid item xs={6} style={{ maxWidth: 'lg' }}>
                        <StyledFilledTextField
                            label="Search Strings"
                            size="small"
                            onChange={onQueryChange}
                            value={searchTerm}
                            fullWidth
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton aria-label="do search">
                                            <SearchIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                    {props.selectedIds?.length > 0 && (<>
                        <Grid item xs={6} container direction="row" justifyContent="flex-end">
                            <Button
                                // style={{ position: 'fixed', top: '0.75rem', right: 20 }}
                                id="basic-button"
                                aria-controls={open ? 'basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                                onClick={handleClick}
                                color="primary"
                                variant="contained"
                                disabled={props.syncActive}
                            >
                                <MenuIcon />
                                &nbsp; Actions
                            </Button>
                            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                                <MenuItem onClick={onBatchDelete}>Remove strings</MenuItem>
                            </Menu>
                        </Grid>
                    </>) }
                    {hasPerm('notification', 'write') && props.isSmallScreen && !props.selectedIds?.length && (
                        <Grid item xs={6} container justifyContent="flex-end">
                            <Button onClick={ev=>props.handleCreateNotification(ev.currentTarget)} variant="contained" color="primary">
                                <AddIcon />
                            </Button>
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </Toolbar>
    );
};

export default NotificationStringToolbar;
